import React from 'react';
import styled from 'styled-components';

const HeaderWrapper = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 0 auto 80px;
`;

const Title = styled.h2`
  font-size: 48px;
  font-weight: 800;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.2;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 36px;
  }
`;

const Subtitle = styled.p`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.gray};
  line-height: 1.7;
`;

const SectionHeader = ({ title, subtitle }) => {
  return (
    <HeaderWrapper>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </HeaderWrapper>
  );
};

export default SectionHeader;